import React, { useEffect, useState, useContext } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"

//i18n
import { withTranslation } from "react-i18next"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import { getUsers } from "../../../store/contacts/actions"
import SetoresListaColunas from "./SetoresListaColunas"
import { isEmpty } from "lodash"

import { getSetores, deleteSetor } from "../../../services/setores"

import PermissaoContext from "../../../contexts/PermissaoContext"

import ModalCadastroSetor from "../../../components/modals/setor/ModalCadastroSetor"
import ModalEdicaoSetor from "../../../components/modals/setor/ModalEdicaoSetor"
import ModalUsuariosSetor from "../../../components/modals/setor/ModalUsuariosSetor"
import ModalMensagensPreDefinidas from "../../../components/modals/setor/ModalMensagensPreDefinidas"

import SweetAlert from "react-bootstrap-sweetalert"

import Carregando from "../../../components/Carregando"
import ModalEdicaoGrupoDeHorario from "../../../components/modals/grupo-de-horario/ModalEdicaoGrupoDeHorario"

const SetoresLista = props => {
  function translate (text) {
    return props.t(text)
  }

  const { users, onGetUsers } = props
  const [list, setList] = useState([])
  const [listView, setListView] = useState([])
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: list.length,
    custom: true
  })
  const { SearchBar } = Search

  const [page, setPage] = useState(1)
  const [searchText, setSearchText] = useState("")

  const [modalCadastroOpened, setModalCadastroOpened] = useState(false)
  const [modalEdicaoOpened, setModalEdicaoOpened] = useState(null)

  const [modalUsuariosSetoresIsOpened, setModalUsuariosSetoresIsOpened] = useState(false)
  const [modalUsuariosSetoresOpened, setModalUsuariosSetoresOpened] = useState(null)

  const [modalHorariosSetoresIsOpened, setModalHorariosSetoresIsOpened] = useState(false)
  const [modalHorariosSetoresOpened, setModalHorariosSetoresOpened] = useState(null)

  const [modalMensagensPreDefinidasIsOpened, setModalMensagensPreDefinidasIsOpened] = useState(false)
  const [modalMensagensPreDefinidasOpened, setModalMensagensPreDefinidasOpened] = useState(null)

  const [sweetAlert, setSweetAlert] = useState({
    show: false,
    title: "",
    text: "",
    confirmBtnBsStyle: "success",
    onConfirm: () => { setSweetAlert({ ...sweetAlert, show: false }) }
  })

  const { permissoes, isLoadingPermissoes } = useContext(PermissaoContext)

  useEffect(() => {
    buscarSetores()
  }, [])

  useEffect(() => {
    setModalUsuariosSetoresIsOpened(modalUsuariosSetoresOpened != null)
  }, [modalUsuariosSetoresOpened])

  useEffect(() => {
    setModalHorariosSetoresIsOpened(modalHorariosSetoresOpened != null)
  }, [modalHorariosSetoresOpened])

  useEffect(() => {
    setModalMensagensPreDefinidasIsOpened(modalMensagensPreDefinidasOpened != null)
  }, [modalMensagensPreDefinidasOpened])

  useEffect(() => {
    if (modalUsuariosSetoresIsOpened == false)
      setModalUsuariosSetoresOpened(null)
  }, [modalUsuariosSetoresIsOpened])

  useEffect(() => {
    if (modalHorariosSetoresIsOpened == false)
      setModalHorariosSetoresOpened(null)
  }, [modalHorariosSetoresIsOpened])

  useEffect(() => {
    if (modalMensagensPreDefinidasIsOpened == false)
      setModalMensagensPreDefinidasOpened(null)
  }, [modalMensagensPreDefinidasIsOpened])

  useEffect(() => {
    if (!isEmpty(users)) {
      setList(users)
    }
  }, [users])

  const buscarSetores = async () => {
    try {
      const setores = await getSetores()

      setList(setores)
      setListView(setores)
    } catch (error) {
    }
  }

  const removerSetor = async (setor) => {
    try {
      console.log("removerSetor", setor)
      setSweetAlert({
        ...sweetAlert,
        show: true,
        title: translate("Atenção!"),
        text: `${translate("Tem certeza que deseja excluir o setor")} ${setor.nome}?`,
        showCancel: true,
        cancelBtnBsText: translate("Não"),
        cancelBtnBsStyle: "danger",
        warning: true,
        onCancel: () => { setSweetAlert({ ...sweetAlert, show: false }) },
        onConfirm: async () => {
          setSweetAlert({ ...sweetAlert, showCancel: false, showConfirm: false, title: translate("Aguarde"), text: translate("Estamos removendo o setor") })
          try {
            let retorno = await deleteSetor(setor.id)
            setSweetAlert({ ...sweetAlert, showConfirm: true, info: false, success: true, title: translate("Sucesso"), text: retorno || translate("Setor removido com sucesso!"), onConfirm: () => { setSweetAlert({ ...sweetAlert, show: false }) } })
            handleRefresh(setor, "remove")
          } catch (error) {
            setSweetAlert({ ...sweetAlert, showConfirm: true, info: false, error: true, title: translate("Ooops"), text: error.message || translate("Ocorreu um erro."), onConfirm: () => { setSweetAlert({ ...sweetAlert, show: false }) } })
          }
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  const handleRefresh = async (setor, action = "add") => {
    console.log("{ handleRefresh }", action, list, setor)
    if (action == "add") {
      let newArray = [...list, setor]
      setList(newArray)
      setPageOptions({ ...pageOptions, totalSize: list.length + 1 })
      handleTableChange(null, { page, searchText }, newArray)
    } else if (action == "edit") {
      let newArray = [...list]
      for (let i = 0; i < newArray.length; i++) {
        const el = newArray[i]
        if (el.id == setor.id) {
          newArray[i] = setor
          break
        }
      }
      handleTableChange(null, { page, searchText }, newArray)
    } else if (action == "remove") {
      let newArray = list.filter(user => user.id != setor.id)
      setList(newArray)
      setPageOptions({ ...pageOptions, totalSize: newArray.length - 1 })
      handleTableChange(null, { page, searchText }, newArray)
    }
  }

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (type, { page, searchText }, data = null) => {
    const dados = data || list
    console.log("{ handleTableChange }", page, searchText, dados)
    setPage(page)
    setSearchText(searchText)

    let inicio = pageOptions.sizePerPage * page - pageOptions.sizePerPage
    let fim = pageOptions.sizePerPage * page
    if (fim > dados.length) fim = dados.length

    setListView(
      dados.slice(inicio, fim).filter(user =>
        Object.keys(user).some(
          key =>
            typeof user[key] === "string" &&
            user[key].toLowerCase().includes(searchText.toLowerCase())
        )
      )
    )
  }

  var selectRowProp = {
    mode: "checkbox",
    clickToSelect: false,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title={translate("Setores")} breadcrumbItem={translate("Lista de Setores")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {isLoadingPermissoes ? <Carregando /> :
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={listView || []}
                          columns={SetoresListaColunas(removerSetor, setModalEdicaoOpened, permissoes, setModalUsuariosSetoresOpened, setModalHorariosSetoresOpened, setModalMensagensPreDefinidasOpened, translate)}
                          bootstrap4
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row className="row mb-2">
                                <Col md={6}>
                                  {permissoes.setores_gerenciamento && <div className="mb-3">
                                    <Link to="#" className="btn btn-success waves-effect waves-light" onClick={() => setModalCadastroOpened(true)}><i className="mdi mdi-plus me-2"></i>{translate("Novo")}</Link>
                                  </div>}
                                </Col>

                                <Col md={6}>
                                  <div className="form-inline float-md-end mb-3">
                                    <div className="search-box ms-2">
                                      <div className="position-relative">
                                        <SearchBar {...toolkitProps.searchProps} />
                                        <i className="mdi mdi-magnify search-icon"></i>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive mb-4">
                                    <BootstrapTable
                                      selectRow={selectRowProp}
                                      responsive
                                      remote
                                      bordered={false}
                                      striped={false}
                                      classes={"table table-centered table-nowrap mb-0"}
                                      {...toolkitProps.baseProps}
                                      onTableChange={handleTableChange}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <div className="float-sm-end">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ModalCadastroSetor opened={modalCadastroOpened} setOpened={setModalCadastroOpened} refresh={handleRefresh} />
      <ModalEdicaoSetor opened={modalEdicaoOpened} setOpened={setModalEdicaoOpened} refresh={handleRefresh} values={modalEdicaoOpened} />
      <ModalUsuariosSetor opened={modalUsuariosSetoresIsOpened} setOpened={setModalUsuariosSetoresIsOpened} setor={modalUsuariosSetoresOpened} />

      <ModalEdicaoGrupoDeHorario opened={modalHorariosSetoresIsOpened} setOpened={setModalHorariosSetoresIsOpened} refresh={handleRefresh} values={modalHorariosSetoresOpened} deSetor={true} />

      <ModalMensagensPreDefinidas opened={modalMensagensPreDefinidasIsOpened} setOpened={setModalMensagensPreDefinidasIsOpened} refresh={handleRefresh} values={modalMensagensPreDefinidasOpened} setor_id={modalMensagensPreDefinidasOpened?.id} />

      {sweetAlert.show && <SweetAlert {...sweetAlert}>{sweetAlert.text}</SweetAlert>}
    </React.Fragment>
  )
}

SetoresLista.propTypes = {
  users: PropTypes.array,
  onGetUsers: PropTypes.func,
}

const mapStateToProps = ({ contacts }) => ({
  users: contacts.users,
})

const mapDispatchToProps = dispatch => ({
  onGetUsers: () => dispatch(getUsers()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(SetoresLista)))
